import React, { useState } from 'react';

const AIAgents = () => {
  const [agents] = useState([
    {
      id: 1,
      name: 'Support-Bot-01',
      description: 'Customer support automation agent',
      status: 'active',
      type: 'Support',
      model: 'GPT-4',
      lastActive: '2 minutes ago',
      totalRequests: 15420,
      successRate: 98.5,
      avgResponseTime: '1.2s'
    },
    {
      id: 2,
      name: 'Marketing-Flow',
      description: 'Lead qualification and nurturing agent',
      status: 'active',
      type: 'Marketing',
      model: 'Claude-3',
      lastActive: '5 minutes ago',
      totalRequests: 8930,
      successRate: 94.2,
      avgResponseTime: '2.1s'
    },
    {
      id: 3,
      name: 'Data-Sync-Agent',
      description: 'Database synchronization and validation',
      status: 'idle',
      type: 'Data Processing',
      model: 'Custom',
      lastActive: '1 hour ago',
      totalRequests: 3456,
      successRate: 99.1,
      avgResponseTime: '0.8s'
    },
    {
      id: 4,
      name: 'Security-Guard',
      description: 'Security monitoring and threat detection',
      status: 'active',
      type: 'Security',
      model: 'GPT-4',
      lastActive: '30 seconds ago',
      totalRequests: 22100,
      successRate: 96.8,
      avgResponseTime: '0.5s'
    }
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-emerald-500 bg-emerald-500/10';
      case 'idle': return 'text-yellow-500 bg-yellow-500/10';
      case 'error': return 'text-red-500 bg-red-500/10';
      case 'training': return 'text-blue-500 bg-blue-500/10';
      default: return 'text-slate-500 bg-slate-500/10';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Support': return 'text-blue-500 bg-blue-500/10';
      case 'Marketing': return 'text-purple-500 bg-purple-500/10';
      case 'Data Processing': return 'text-orange-500 bg-orange-500/10';
      case 'Security': return 'text-red-500 bg-red-500/10';
      default: return 'text-slate-500 bg-slate-500/10';
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-black text-white tracking-tight">AI Agents</h2>
          <p className="text-[#92b7c9] mt-1">Deploy and manage your specialized AI agents.</p>
        </div>
        <button className="bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 transition-colors">
          <span className="material-symbols-outlined">smart_toy</span>
          Deploy New Agent
        </button>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-primary/10 rounded-lg">
              <span className="material-symbols-outlined text-primary">smart_toy</span>
            </div>
            <span className="text-xs text-emerald-500 font-bold">+2 this week</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Total Agents</p>
          <h3 className="text-white text-2xl font-bold mt-1">12</h3>
        </div>

        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-emerald-500/10 rounded-lg">
              <span className="material-symbols-outlined text-emerald-500">sensors</span>
            </div>
            <span className="text-xs text-emerald-500 font-bold">9 active</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Active Agents</p>
          <h3 className="text-white text-2xl font-bold mt-1">9</h3>
        </div>

        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <span className="material-symbols-outlined text-blue-500">psychology</span>
            </div>
            <span className="text-xs text-blue-500 font-bold">+15% vs last month</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Total Requests</p>
          <h3 className="text-white text-2xl font-bold mt-1">49.9K</h3>
        </div>

        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-purple-500/10 rounded-lg">
              <span className="material-symbols-outlined text-purple-500">speed</span>
            </div>
            <span className="text-xs text-purple-500 font-bold">1.2s avg</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Avg Response Time</p>
          <h3 className="text-white text-2xl font-bold mt-1">1.2s</h3>
        </div>
      </div>

      {/* Agents Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {agents.map((agent) => (
          <div key={agent.id} className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6 hover:border-primary/50 transition-colors">
            <div className="flex justify-between items-start mb-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <span className="material-symbols-outlined text-primary text-xl">smart_toy</span>
                </div>
                <div>
                  <h3 className="text-white font-bold text-lg">{agent.name}</h3>
                  <p className="text-slate-400 text-sm">{agent.description}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`px-2 py-1 rounded-full text-xs font-bold capitalize ${getStatusColor(agent.status)}`}>
                  {agent.status}
                </span>
                <button className="text-slate-400 hover:text-white p-1 rounded transition-colors">
                  <span className="material-symbols-outlined text-sm">more_vert</span>
                </button>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <p className="text-slate-400 text-xs font-medium">Type</p>
                <span className={`inline-block px-2 py-1 rounded-full text-xs font-bold mt-1 ${getTypeColor(agent.type)}`}>
                  {agent.type}
                </span>
              </div>
              <div>
                <p className="text-slate-400 text-xs font-medium">Model</p>
                <p className="text-white font-semibold text-sm mt-1">{agent.model}</p>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-4 pt-4 border-t border-slate-200 dark:border-[#233c48]">
              <div>
                <p className="text-slate-400 text-xs font-medium">Requests</p>
                <p className="text-white font-bold text-sm mt-1">{agent.totalRequests.toLocaleString()}</p>
              </div>
              <div>
                <p className="text-slate-400 text-xs font-medium">Success Rate</p>
                <p className="text-emerald-500 font-bold text-sm mt-1">{agent.successRate}%</p>
              </div>
              <div>
                <p className="text-slate-400 text-xs font-medium">Response Time</p>
                <p className="text-blue-500 font-bold text-sm mt-1">{agent.avgResponseTime}</p>
              </div>
            </div>

            <div className="flex justify-between items-center pt-4 border-t border-slate-200 dark:border-[#233c48]">
              <p className="text-slate-400 text-xs">Last active: {agent.lastActive}</p>
              <div className="flex items-center gap-2">
                <button className="bg-slate-100 dark:bg-[#233c48] hover:bg-slate-200 dark:hover:bg-[#2a4a5a] text-slate-600 dark:text-slate-300 px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors">
                  Configure
                </button>
                <button className="bg-primary hover:bg-primary/90 text-white px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors">
                  View Details
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Quick Deploy Section */}
      <div className="bg-gradient-to-br from-primary/10 to-blue-500/10 border border-primary/20 rounded-xl p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-white font-bold text-lg">Quick Deploy Templates</h3>
            <p className="text-slate-400 text-sm">Deploy pre-configured agents for common use cases</p>
          </div>
          <span className="material-symbols-outlined text-primary text-2xl">rocket_launch</span>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-white/5 border border-white/10 rounded-lg p-4 hover:bg-white/10 transition-colors cursor-pointer">
            <div className="flex items-center gap-3 mb-2">
              <span className="material-symbols-outlined text-blue-500">support_agent</span>
              <h4 className="text-white font-semibold">Customer Support</h4>
            </div>
            <p className="text-slate-400 text-xs">24/7 customer support automation</p>
          </div>
          
          <div className="bg-white/5 border border-white/10 rounded-lg p-4 hover:bg-white/10 transition-colors cursor-pointer">
            <div className="flex items-center gap-3 mb-2">
              <span className="material-symbols-outlined text-purple-500">campaign</span>
              <h4 className="text-white font-semibold">Lead Qualification</h4>
            </div>
            <p className="text-slate-400 text-xs">Automated lead scoring and routing</p>
          </div>
          
          <div className="bg-white/5 border border-white/10 rounded-lg p-4 hover:bg-white/10 transition-colors cursor-pointer">
            <div className="flex items-center gap-3 mb-2">
              <span className="material-symbols-outlined text-orange-500">analytics</span>
              <h4 className="text-white font-semibold">Data Analysis</h4>
            </div>
            <p className="text-slate-400 text-xs">Intelligent data processing and insights</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIAgents;